var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24418_21404)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3634 3.40738C14.5508 3.59491 14.6562 3.84921 14.6562 4.11438C14.6562 4.37954 14.5508 4.63385 14.3634 4.82138L6.86803 12.3167C6.76898 12.4158 6.65138 12.4944 6.52195 12.548C6.39252 12.6016 6.2538 12.6292 6.1137 12.6292C5.9736 12.6292 5.83488 12.6016 5.70545 12.548C5.57602 12.4944 5.45842 12.4158 5.35937 12.3167L1.63537 8.59338C1.53986 8.50113 1.46367 8.39079 1.41126 8.26878C1.35886 8.14678 1.33127 8.01556 1.33012 7.88278C1.32896 7.75 1.35426 7.61832 1.40454 7.49542C1.45483 7.37253 1.52908 7.26087 1.62297 7.16698C1.71686 7.07309 1.82852 6.99884 1.95141 6.94856C2.07431 6.89827 2.20599 6.87297 2.33877 6.87413C2.47155 6.87528 2.60277 6.90287 2.72477 6.95528C2.84677 7.00768 2.95712 7.08387 3.04937 7.17938L6.11337 10.2434L12.9487 3.40738C13.0416 3.31445 13.1518 3.24073 13.2732 3.19044C13.3946 3.14014 13.5247 3.11426 13.656 3.11426C13.7874 3.11426 13.9175 3.14014 14.0389 3.19044C14.1602 3.24073 14.2705 3.31445 14.3634 3.40738Z",
    fill: "#32BC69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24418_21404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.3ffe2cf5b9e6e548d2f926a8c8f178d2.svg";
export { ForwardRef as ReactComponent };